import { AbstractControl, ValidationErrors } from '@angular/forms';

export function decimalValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  // Check if value contains "e"
  if (value && value.toString().includes('e')) {
    return { decimal: true };
  }

  // Check for maximum of 2 decimal points
  const decimalRegex = /^\d+(\.\d{1,2})?$/;
  if (value && !decimalRegex.test(value)) {
    return { decimal: true };
  }

  return null; // Valid input
}
